'use client';

import { HiAcademicCap, HiBriefcase, HiBuildingOffice2, HiCalendarDays, HiHome, HiUserGroup } from 'react-icons/hi2';
import React from 'react';
import { Locale } from '../../../../i18n-config';
import RoleTilesGrid, { RoleTileItem } from '../_shared/sections/RoleTilesGrid';
import { useTranslation } from '@/i18n/client';

type Props = {
  lang: Locale;
};

type RoleKey = 'trainer' | 'venue' | 'consultant' | 'agency' | 'clinic' | 'rental';

const ROLE_ICONS: Record<RoleKey, RoleTileItem['Icon']> = {
  trainer: HiAcademicCap,
  venue: HiCalendarDays,
  consultant: HiBriefcase,
  agency: HiBuildingOffice2,
  clinic: HiUserGroup,
  rental: HiHome,
};

const ROLE_KEYS: readonly RoleKey[] = ['trainer', 'venue', 'consultant', 'agency', 'clinic', 'rental'] as const;

const ESignatureExamples = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const roles: RoleTileItem[] = ROLE_KEYS.map((key) => ({
    key,
    Icon: ROLE_ICONS[key],
    name: t(`ESignature/Examples/${key}_name`),
    line: t(`ESignature/Examples/${key}_line`),
    metric: t(`ESignature/Examples/${key}_metric`),
    metricLabel: t(`ESignature/Examples/${key}_metric_label`),
  }));

  return (
    <RoleTilesGrid
      num="03"
      label={t('ESignature/Examples/badge')}
      headlineA={t('ESignature/Examples/title')}
      headlineB={t('ESignature/Examples/headline_b')}
      subhead={t('ESignature/Examples/subtitle')}
      roles={roles}
    />
  );
};

export default ESignatureExamples;
